import $ from "jquery";
import {sendFilterEvent} from "./legacy-analytics";
import {sendFilterEvent as sendAnalytics4} from "./google-analytics4";

function sendFilterEvents(obj) {
    let $obj = $(obj);
    if ($obj.closest("[data-ae]").length > 0) {
        let label = $obj.closest("[data-ae]").data('ae');
        let value = cleanLabel(normalize($obj.text()));
        let action = $obj.find('label').hasClass('checkSelected') ? 'check' : 'uncheck';
        sendFilterEvent(label, value);
        sendAnalytics4(label, value, action);
    }
}

function normalize(text) {
    return text
        .toLowerCase()
        .trim()
        .replace(/\n/g, '')
        .replace(/\t/g, '')
        .replace(/ /g, '_')
        .replace(/:/g, '_')
        .replace('__', '_');
}

function cleanLabel(label) {
    if (label.indexOf("_(") !== -1 && label.indexOf(")") !== -1 && label.indexOf("_(") < label.lastIndexOf(")")) {
        label = label.substr(0, label.indexOf("_("));
    }
    return label;
}

export function initCheckboxesEvents() {
    //We rewrite event uExternalRefresh links from filtro div
    let $filterElements = $('.filtro');
    $filterElements.off("click", '.uExternalRefresh');
    $filterElements.on("click", '.uExternalRefresh', function () {

        sendFilterEvents(this);

    });
}